/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { PutUpdateDebtorCollectionMutationRequest, PutUpdateDebtorCollectionMutationResponse, PutUpdateDebtorCollectionPathParams, PutUpdateDebtorCollection400, PutUpdateDebtorCollection401, PutUpdateDebtorCollection403 } from "../../models/PutUpdateDebtorCollection";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getPutUpdateDebtorCollectionUrl({ debtorCode, collectionId }: { debtorCode: PutUpdateDebtorCollectionPathParams["debtorCode"]; collectionId: PutUpdateDebtorCollectionPathParams["collectionId"] }) {
  const res = { method: 'PUT', url: `/api/v1/debtors/${debtorCode}/collections/${collectionId}` as const }  
  return res
}

/**
 * {@link /api/v1/debtors/:debtorCode/collections/:collectionId}
 */
export async function putUpdateDebtorCollection({ debtorCode, collectionId, data }: { debtorCode: PutUpdateDebtorCollectionPathParams["debtorCode"]; collectionId: PutUpdateDebtorCollectionPathParams["collectionId"]; data: PutUpdateDebtorCollectionMutationRequest }, config: Partial<RequestConfig<PutUpdateDebtorCollectionMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<PutUpdateDebtorCollectionMutationResponse, ResponseErrorConfig<PutUpdateDebtorCollection400 | PutUpdateDebtorCollection401 | PutUpdateDebtorCollection403>, PutUpdateDebtorCollectionMutationRequest>({ method : "PUT", url : getPutUpdateDebtorCollectionUrl({ debtorCode, collectionId }).url.toString(), data : requestData, ... requestConfig })  
  return res.data
}